import { fetcher } from "helpers/fetcher";

import { TGetStaffAcademicAndQualificationRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getStaffAcademicAndQualification = async (userId: string) => {
  return await fetcher<TGetStaffAcademicAndQualificationRes, any>(
    ENDPOINT.USER.GET_STAFF_ACADEMIC_QUALIFICATION,
    {
      headers: {
        [API_HEADER.VERSION]:
          ENDPOINT.USER.GET_STAFF_ACADEMIC_QUALIFICATION.version,
        [API_HEADER.USER_ID]: userId,
      },
    }
  );
};

export const queryGetStaffAcademicAndQualification = async (userId: string) => {
  return (await getStaffAcademicAndQualification(userId)).data;
};

queryGetStaffAcademicAndQualification._key = (userId: string) => [
  ENDPOINT.USER.GET_STAFF_ACADEMIC_QUALIFICATION.url,
  userId,
];
